(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcu-luxury-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dcu-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-dcu-slide]')];
    const dots = [...hero.querySelectorAll('[data-dcu-dot]')];
    if (slides.length < 2) return;
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === active); dot.setAttribute('aria-current', i === active ? 'true' : 'false'); });
    };
    const start = () => { if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), 6500); };
    const reset = () => { window.clearInterval(timer); start(); };
    hero.querySelector('[data-dcu-prev]')?.addEventListener('click', () => { show(active - 1); reset(); });
    hero.querySelector('[data-dcu-next]')?.addEventListener('click', () => { show(active + 1); reset(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); reset(); }));
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dcu-velum-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dcu-header]').forEach((header) => {
    const dockMenu = header.querySelector('[data-dcu-bottom-menu]');
    const drawer = header.querySelector('.dcu-drawer');
    dockMenu?.addEventListener('click', () => {
      if (drawer) drawer.open = true;
    });
    const announcements = [...header.querySelectorAll('.dcu-mobile-announcement')];
    if (announcements.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let announcementIndex = 0;
      window.setInterval(() => {
        announcements[announcementIndex].classList.remove('is-active');
        announcementIndex = (announcementIndex + 1) % announcements.length;
        announcements[announcementIndex].classList.add('is-active');
      }, 4500);
    }
    const desktopAnnouncements = [...header.querySelectorAll('.dcu-desktop-announcement')];
    if (desktopAnnouncements.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let desktopIndex = 0;
      window.setInterval(() => {
        desktopAnnouncements[desktopIndex].classList.remove('is-active');
        desktopIndex = (desktopIndex + 1) % desktopAnnouncements.length;
        desktopAnnouncements[desktopIndex].classList.add('is-active');
      }, 4500);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
